import { createReducer, on } from '@ngrx/store';
import { HomeMyHealthPassportHealthRecordActions } from './health-record.actions';
import {
  HomeMyHealthPassportHealthRecordState,
  homeMyHealthPassportHealthRecordState
} from './health-record.state';

export const homeMyHealthPassportHealthRecordReducer = createReducer(
  homeMyHealthPassportHealthRecordState,
  on(
    HomeMyHealthPassportHealthRecordActions.reset,
    (): HomeMyHealthPassportHealthRecordState => ({
      data: [],
      error: false,
      loading: false
    })
  ),
  on(
    HomeMyHealthPassportHealthRecordActions.setData,
    (state, { data }): HomeMyHealthPassportHealthRecordState => ({
      ...state,
      data
    })
  ),
  on(
    HomeMyHealthPassportHealthRecordActions.setError,
    (state, { error }): HomeMyHealthPassportHealthRecordState => ({
      ...state,
      error
    })
  ),
  on(
    HomeMyHealthPassportHealthRecordActions.setLoading,
    (state, { loading }): HomeMyHealthPassportHealthRecordState => ({
      ...state,
      loading
    })
  )
);
